import React from 'react';
import { webUrlToUrlState, PageType } from '@westwing/looks-url-service';
import { ErrorBoundary } from '../Generic/ErrorBoundaries';
import { LDPSeoHead } from './LooksDetailPage/SeoHead';
import SkipRender from 'Client/components/Generic/SkipRender';
import useRouter from 'Client/hooks/useRouter';
import LooksDetailPage from 'Client/components/Looks/LooksDetailPage';
import LooksListingPage from 'Client/components/Looks/LooksListingPage';
import { useLogger } from 'Client/logger/LoggerProvider';

export const LDPErrorBoundary = ({ children }: { children: React.ReactNode }) => {
    const logger = useLogger();

    return (
        <ErrorBoundary logger={logger} boundaryName="LooksDetailPage" fallbackComponent={<LooksListingPage />}>
            {children}
        </ErrorBoundary>
    );
};

const Looks = () => {
    const {
        location: { pathname },
    } = useRouter();

    const { pageType, rooms, styles, look } = webUrlToUrlState(pathname);
    if (pageType === PageType.UNKNOWN) {
        // should never happen, because react-router route already checks for path "/looks"
        return <SkipRender message={`user landed on the looks unknown page with path: ${pathname}`} />;
    }

    if (pageType === PageType.LDP && !!look) {
        return (
            <LDPErrorBoundary>
                <LDPSeoHead />
                <LooksDetailPage lookSlug={look} />
            </LDPErrorBoundary>
        );
    }

    return <LooksListingPage initialRoom={rooms?.[0]} initialStyle={styles?.[0]} />;
};

export default Looks;
